import { RuleProps } from 'types/application';

export const CERTIFICATE_CATEGORY = 'certificate-category';
export const CERTIFICATE_MAILING_ADDRESS = 'certificate-mailing-address';
export const LOCAL_ADDRESS = 'local-address';
export const OVERSEAS_ADDRESS = 'overseas-address';
export const CERTIFICATE_OWNER_PARTICULARS = 'certificate-owner-particulars';
export const CERTIFICATE_INFORMATION = 'certificate-information';
export const OPERATOR_EXAM_DETAILS = 'operator-exam-details';
export const BOOKLET = 'booklet';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const AMEND_SSOC_APPLICATION = [
    {
        sectionID: CERTIFICATE_CATEGORY,
        sectionName: 'Certificate Category',
        fieldList: [
            {
                id: 'amend-table',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'type',
                        header: 'I want to amend',
                        type: 'text'
                    }
                ],
                span: 12
            },
            {
                id: 'please-select-the-certification-you-want-to-apply',
                label: 'Please select the certification you want to apply',
                type: 'text'
            }
        ]
    },
    {
        sectionID: CERTIFICATE_MAILING_ADDRESS,
        sectionName: 'Certificate Mailing Address',
        fieldList: [
            {
                id: 'collection-method',
                label: 'Collection Method',
                type: 'text'
            },
            {
                id: 'same-as-billing-address',
                label: 'Same As Billing Address',
                type: 'text',
                rule: {
                    baseIds: [`${CERTIFICATE_MAILING_ADDRESS}-collection-method`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(
                            (baseValues && baseValues[`${CERTIFICATE_MAILING_ADDRESS}-collection-method`] === 'DELIVERY-SINGAPORE') ||
                                (baseValues && baseValues[`${CERTIFICATE_MAILING_ADDRESS}-collection-method`] === 'DELIVERY-OVERSEA')
                        );
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: LOCAL_ADDRESS,
        sectionName: 'Local Address',
        fieldList: [
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'floor-level',
                label: 'Floor/Level (Optional)',
                type: 'text'
            },
            {
                id: 'unit',
                label: 'Unit (Optional)',
                type: 'text'
            }
        ],
        rule: {
            baseIds: [`${CERTIFICATE_MAILING_ADDRESS}-collection-method`, `${CERTIFICATE_MAILING_ADDRESS}-same-as-billing-address`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = !Boolean(
                    baseValues &&
                        baseValues[`${CERTIFICATE_MAILING_ADDRESS}-collection-method`] === 'DELIVERY-SINGAPORE' &&
                        baseValues[`${CERTIFICATE_MAILING_ADDRESS}-same-as-billing-address`] === 'No'
                );
                return result;
            }
        }
    },
    {
        sectionID: OVERSEAS_ADDRESS,
        sectionName: 'Overseas Address',
        fieldList: [
            {
                id: 'foreign-address-line-one',
                label: 'Foreign Address Line 1',
                type: 'text'
            },
            {
                id: 'foreign-address-line-two',
                label: 'Foreign Address Line 2',
                type: 'text'
            },
            {
                id: 'foreign-address-line-three',
                label: 'Foreign Address Line 3',
                type: 'text',
                span: 12
            },
            {
                id: 'city',
                label: 'City',
                type: 'text'
            },
            {
                id: 'state',
                label: 'State',
                type: 'text'
            },
            {
                id: 'zip-code',
                label: 'Zip Code',
                type: 'text'
            },
            {
                id: 'country',
                label: 'Country',
                type: 'text'
            }
        ],
        rule: {
            baseIds: [`${CERTIFICATE_MAILING_ADDRESS}-collection-method`, `${CERTIFICATE_MAILING_ADDRESS}-same-as-billing-address`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = !Boolean(
                    baseValues &&
                        baseValues[`${CERTIFICATE_MAILING_ADDRESS}-collection-method`] === 'DELIVERY-OVERSEA' &&
                        baseValues[`${CERTIFICATE_MAILING_ADDRESS}-same-as-billing-address`] === 'No'
                );
                return result;
            }
        }
    },
    {
        sectionID: CERTIFICATE_OWNER_PARTICULARS,
        sectionName: `Certificate's Owner Particulars`,
        fieldList: [
            {
                id: 'owner-name',
                label: 'Owner Name',
                type: 'text'
            },
            {
                id: 'sex',
                label: 'Sex',
                type: 'text'
            },
            {
                id: 'date-of-birth',
                label: 'Date Of Birth',
                type: 'text'
            },
            {
                id: 'id-type',
                label: 'ID Type',
                type: 'text'
            },
            {
                id: 'nationality',
                label: 'Nationality',
                type: 'text'
            },
            {
                id: 'place-of-birth',
                label: 'Place Of Birth',
                type: 'text'
            },
            {
                id: 'height',
                label: 'Height (cm)',
                type: 'text'
            },
            {
                id: 'colour-of-eyes',
                label: 'Colour Of Eyes',
                type: 'text'
            },
            {
                id: 'colour-of-hair',
                label: 'Colour Of Hair',
                type: 'text'
            },
            {
                id: 'complexion',
                label: 'Complexion',
                type: 'text'
            },
            {
                id: 'visible-peculiarities',
                label: 'Visible Peculiarities',
                type: 'text',
                span: 12
            },
            {
                id: 'medical-certificate-issue-date',
                label: 'Medical Certificate Issue Date',
                type: 'text'
            },
            {
                id: 'medical-certificate-expiry-date',
                label: 'Medical Certificate Expiry Date',
                type: 'text'
            },
            {
                id: 'cdc-no',
                label: 'CDC No.',
                type: 'text'
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
